<template>
    <div class="homeinterativa">
        <PageTitle icon="fas fa-tools iconInterativoTitulo" main="Eficiência da Operação"
            sub="Acompanhe a eficiência de sua operação em tempo Real" />
        <div class="stats">
            <Stat title="Metas" :value="stat.maquinas"
                icon="fab fa-algolia" color="#2e2d2c" />
            <Stat title="Ranking" :value="stat.baterias"
                icon="fas fa-chart-bar" color="#ffd618" />
            <Stat title="Histórico" :value="stat.usuarios"
                icon="fas fa-history" color="#008fac" />
        </div>
    </div>
</template>

<script>
import PageTitle from '../PageTitle'
import Stat from './Stat'
import axios from 'axios'
import { baseApiUrl } from '@/global'

export default {
    name: 'OperacaoInterativa',
    components: { PageTitle, Stat },
    data: function() {
        return {
            stat: {}
        }
    },
    methods: {
        getStats() {
            axios.get(`${baseApiUrl}/stats`).then(res => this.stat = res.data)
        }
    },
    mounted() {
        this.getStats()
    }
}
</script>

<style>
    .stats {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 20px;
    }
    .homeinterativa{
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>